module.exports = __webpack_public_path__ + "img/floor-display.c7828f1d.jpg";